export default function RoundTo(input, decimalPlaces = 2) {
    decimalPlaces = Math.floor(Math.max(1, decimalPlaces));
    let places = 10 ** decimalPlaces;
    return Math.round(input * places) / places;
}